"use client";

import { getConvertedJpeg } from "api/get-converted-jpeg.api";
import { useIntersectionObserver } from "hooks-contexts/useIntersectionObserver";
import {
  CSSProperties, ReactNode, useEffect, useState,
} from "react";
import { getAbsoluteImagePath } from "util/helper/getAbsoluteImagePath";
import { checkWebPSupport } from "./checkWebpSupport";

interface Props {
  src: string;
  className?: string;
  children?: ReactNode;
  style?: CSSProperties;
}
const LazyBackgroundImage = (props: Props) => {
  const {
    src, className = "", children,
    style,
  } = props;
  const [imgSrc, setImgSrc] = useState(src);
  const { ref, isVisible } = useIntersectionObserver();

  useEffect(() => {
    if (!isVisible) {
      return;
    }
    const processImageFormat = async () => {
      const isWebpSupported = await checkWebPSupport(src);
      if (!isWebpSupported) {
        const absoluteSrc = getAbsoluteImagePath(src);
        getConvertedJpeg(absoluteSrc)
          .then((base64) => {
            setImgSrc(`data:image/jpeg;base64,${base64}`);
          });
      }
    };
    processImageFormat();
  }, [isVisible]);

  return (
    <div
      ref={ref}
      className={className}
      style={{
        ...(isVisible && {
          backgroundImage: `url(${imgSrc})`,
        }),
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default LazyBackgroundImage;
